// extracted by mini-css-extract-plugin
var _1 = "ScrollArea-module__container--YAPLN";
export { _1 as "container" }
